

// Product Slider

$(document).ready(function($) {
    $('.product-main-images').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      fade: false,
      infinite: false,
      accessibility: false,
      adaptiveHeight: true,
      prevArrow: '<button type="button" class="slick-prev"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.77148 10.2827L1.34667 5.85789L5.77149 1.43308" stroke="#1D1D1D" stroke-width="1.1062" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.59668 1.43286L5.0215 5.85768L0.59668 10.2825" stroke="#1D1D1D" stroke-width="1.1062" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      asNavFor: '.product-thumb-images'
    });
    
    $('.product-thumb-images').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: '.product-main-images',
      dots: false,
      arrows: false,
      prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(267.243 396.545) rotate(180)" fill="#030504"/></svg></button>',
      nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(-251.019 -383.905)" fill="#030504"/></svg></button>',
      infinite: false,
      vertical: true,
      autoplay: false,
      centerPadding: "0px",
      adaptiveHeight: false,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            vertical: false,
            slidesToShow: 5,
            arrows: false,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            slidesToShow: 5,
            arrows: false,
            slidesToScroll: 1
          },
        }
      ]
    });

});


// PhotoSwipe

(function($) {

  // Init empty gallery array
  let galleryArray = [];

  // Loop over gallery items and push it to the array
  $('.gallery').find('figure').each(function() {
    var $link = $(this).find('a'),
      item = {
        src: $link.attr('href'),
        w: $link.data('width'),
        h: $link.data('height'),
        title: $link.attr('title') 
      };
    galleryArray.push(item);
  });
	
	console.log(galleryArray);
  
  // Define click event on gallery item
  $('.open-galley').click(function(event) {

    // Prevent location change
    event.preventDefault();

    // Define object and gallery options
    var $pswp = $('.pswp')[0],
      options = {
        index: $(this).parent('figure').index(),
        bgOpacity: 0.85,
        showHideOpacity: true
      };
    
    // Initialize PhotoSwipe
    var gallery = new PhotoSwipe($pswp, PhotoSwipeUI_Default, galleryArray, options);
    gallery.init();
  });

}(jQuery));


document.addEventListener('DOMContentLoaded', function () {
    // Initialize icon visibility for all products
    document.querySelectorAll('.product-item').forEach(productItem => {
        const openIcon = productItem.querySelector('.open-icon');
        const closeIcon = productItem.querySelector('.close-icon');
        
        if (openIcon) openIcon.style.display = 'inline-block';
        if (closeIcon) closeIcon.style.display = 'none';
    });

    // Add click event listener to each info-icon
    document.querySelectorAll('.info-icon').forEach(infoIcon => {
        infoIcon.addEventListener('click', function () {
            const productItem = this.closest('.product-item');
            const productInfoDetails = productItem.querySelector('.product-info-details');
            const openIcon = this.querySelector('.open-icon');
            const closeIcon = this.querySelector('.close-icon');

            // Toggle the "active" class on the details box
            if (productInfoDetails) {
                productInfoDetails.classList.toggle('active');
            }

            // Toggle visibility of icons
            if (openIcon && closeIcon) {
                openIcon.style.display = openIcon.style.display === 'none' ? 'inline-block' : 'none';
                closeIcon.style.display = closeIcon.style.display === 'none' ? 'inline-block' : 'none';
            }
        });
    });
});


// Shop By Solution

$(document).ready(function ($) {
  jQuery(".shop-by-solution-slider").owlCarousel({
    autoplay: false,
    lazyLoad: true,
    loop: true,
    center: false, // Keep slides aligned, adjust for spacing
    margin: 40, // Add 40px spacing between slides
    stagePadding: 0, // No extra padding on stage
    responsiveClass: true,
    autoHeight: true,
    autoplayTimeout: 7000,
    smartSpeed: 300,
    nav: true,
    navText: [
      '<svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13.5" cy="13.5" r="12.7703" transform="rotate(-180 13.5 13.5)" stroke="#2F2D28" stroke-width="1.45946"/><path d="M15.8818 19.0588L9.5289 12.7059L15.8818 6.35296" stroke="#2F2D28" stroke-width="1.45946" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<svg width="28" height="27" viewBox="0 0 28 27" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="13.7969" cy="13.5" r="12.7703" stroke="#2F2D28" stroke-width="1.45946"/><path d="M11.415 7.94116L17.768 14.2941L11.415 20.647" stroke="#2F2D28" stroke-width="1.45946" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    ],
    dots: false,
    slideBy: 1,
    responsive: {
      0: {
        items: 1.7, // Show 1.5 slides on mobile
        center: false, // Prevent centering
        margin: 10,
        stagePadding: 0 // No padding for mobile
      },
      767: {
        items: 1.5, // Same 1.5 slides for tablets below 991px
        stagePadding: 0 // No padding for tablets
      },
      991: {
        items: 2.5, // Show 2.5 slides on desktop
      },
      1200: {
        items: 2.5, // Keep 2.5 slides on larger screens
      }
    }
  });
});


// Award Winning

// $(document).ready(function($) {
    
//     $('.logo-slider').slick({
//       slidesToShow: 5,
//       slidesToScroll: 1,
//       asNavFor: '.product-main-images',
//       dots: false,
//       arrows: false,
//       prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(267.243 396.545) rotate(180)" fill="#030504"/></svg></button>',
//       nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="16.224" height="12.64" viewBox="0 0 16.224 12.64"><path id="Path_2" data-name="Path 2" d="M251.364,390.571h14.708l-5.383,5.378a.349.349,0,0,0,.494.494l5.966-5.972a.308.308,0,0,0,.043-.053.209.209,0,0,0,.016-.026l.017-.035.01-.035a.143.143,0,0,0,0-.029.342.342,0,0,0,0-.135.143.143,0,0,0,0-.029l-.01-.035-.017-.035a.2.2,0,0,0-.016-.026.307.307,0,0,0-.043-.054l-5.966-5.972A.345.345,0,0,0,260.7,384l-.006.005a.345.345,0,0,0,0,.489h0l5.383,5.383H251.364a.345.345,0,1,0,0,.691Z" transform="translate(-251.019 -383.905)" fill="#030504"/></svg></button>',
//       infinite: false,
//       vertical: true,
//       autoplay: false,
//       centerPadding: "0px",
//       adaptiveHeight: false,
//       centerMode: false,
//       focusOnSelect: true,
//       responsive: [
//         {
//           breakpoint: 992,
//           settings: {
//             vertical: false,
//             slidesToShow: 4,
//             arrows: false,
//             slidesToScroll: 1
//           }
//         },
//         {
//           breakpoint: 768,
//           settings: {
//             vertical: false,
//             slidesToShow: 1,
//             arrows: false,
//             autoplay: false,
//             slidesToScroll: 1
//           },
//         }
//       ]
//     });

// });



// $(document).ready(function () {
//     $(".accordion_head").click(function () {
//         var accordion = $(this).closest(".tech__accordion"); // Use the correct class selector
//         var plusminus = $(this).find(".plusminus");

//         // Close all other accordions
//         $(".accordion_body").slideUp(300);
//         $(".plusminus").html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.582 11.1665L13.332 16.1665L7.08203 11.1665" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
//         $(".tech__accordion").removeClass("active");

//         // Toggle the clicked accordion
//         if ($(this).next(".accordion_body").is(":visible")) {
//             $(this).next(".accordion_body").slideUp(300);
//             plusminus.html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.582 11.1665L13.332 16.1665L7.08203 11.1665" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
//             accordion.removeClass("active");
//         } else {
//             $(this).next(".accordion_body").slideDown(300);
//             plusminus.html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.08203 14.8333L12.332 9.83325L18.582 14.8333" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
//             accordion.addClass("active");
//         }
//     });
// });


$(document).ready(function () {
    $(".accordion_head").click(function () {
        var accordion = $(this).closest(".tech__accordion"); // Current accordion container
        var plusminus = $(this).find(".plusminus");
        var accordionBody = $(this).next(".accordion_body");

        // Get the index of the clicked accordion
        var accordionIndex = $(".accordion_head").index(this);

        // Close all other accordions
        $(".accordion_body").slideUp(300);
        $(".plusminus").html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.582 11.1665L13.332 16.1665L7.08203 11.1665" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        $(".tech__accordion").removeClass("active");
        $(".tab-image-box").removeClass("active"); // Remove active class from all tab-image-box elements

        // Toggle the clicked accordion
        if (accordion.hasClass("active")) {
            // Close the current accordion
            accordionBody.slideUp(300);
            plusminus.html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19.582 11.1665L13.332 16.1665L7.08203 11.1665" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            accordion.removeClass("active");
        } else {
            // Open the clicked accordion
            accordionBody.slideDown(300);
            plusminus.html('<svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.08203 14.8333L12.332 9.83325L18.582 14.8333" stroke="#0E2517" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>');
            accordion.addClass("active");

            // Add active class to the corresponding tab-image-box
            $(".tab-image-box").eq(accordionIndex).addClass("active");
        }
    });
});


$('.where-find-slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows : true,
  prevArrow: [
    '<button type="button" class="slick-prev" aria-label="', theme.strings.previous, '">',
    '<span class="hide-until-sm">',
    theme.icons.chevronLightLeft,
    '</span>',
    '<span class="show-until-sm">',
    theme.icons.arrowLeft,
    '</span>',
    '</button>'].
    join(''),
  nextArrow: [
    '<button type="button" class="slick-next" aria-label="', theme.strings.next, '">',
    '<span class="hide-until-sm">',
    theme.icons.chevronLightRight,
    '</span>',
    '<span class="show-until-sm">',
    theme.icons.arrowRight,
    '</span>',
    '</button>'].
    join(''),
  autoplay: true,
  autoplaySpeed: 0,
  speed: 3000,
  pauseOnHover: true,
  draggable: true,
  swipeToSlide:true,
  cssEase: 'linear',
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 767,
      settings: {
        centerMode: true,
        centerPadding: '40px',
        slidesToShow: 1
      }
    }
  ]
});

$(function() {
    $('.pdp-videos-button').on('click', function() {
        $('body').addClass('video-open');
    });

    $('.pdp-videos-close').on('click', function() {
        $('body').removeClass('video-open');
    });
});